<div class="item_wrapper">
  <div
    class="item"
    *ngFor="let item of items | slice:0:2; let i = index"
  >
    <span class="item_title">{{ item.label }}: </span>
    <span class="item_value">{{ item.number | number: "1.0-2" }}</span>
    <span class="item_trend" *ngIf="displayArrow">
      <i
        class="fas fa-arrow-up"
        *ngIf="item.up "
      ></i>
      <i
        class="fas fa-arrow-down"
        *ngIf="item.down"
      ></i>
    </span>
  </div>
</div>
<div class="item item--clickable" (click)="openExpandDialog($event)" *ngIf="list?.length > 2 || params.isFeeMonitor">
  <i class="fas fa-chevron-down"></i>
</div>

<div class="gray-arrow" *ngIf="params.isWhsTooltip || params.isRepWhsTooltip">
  {{value | number}}
  <div class="item item--clickable" *ngIf="value" (click)="openExpandWarehouse($event)"><i class="fas fa-chevron-down"></i></div>
</div>
